export enum PetCreateStep {
  PetName = 1,
  PetType,
  Gender,
  Age,
}
